<template>
  <b-form-textarea v-if="isTextarea"
      :type="inputType"
      v-model="valueData"
      @focus="startEdit"
      @blur="endEdit"
      @keyup.esc="cancelEdit"
      ref="input"
      class="editable-input"
      :class="{active: editing}"
      placeholder="-"
      :rows="rows"
      :max-rows="maxRows"
      :disabled="disabled"
      :state="state"
      lazy-formatter
      :formatter="formatter"
      :key="componentKey"
  />
  <b-form-input v-else
      :type="inputType"
      v-model="valueData"
      @focus="startEdit"
      @blur="endEdit"
      @keyup.enter="forceBlur"
      @keyup.esc="cancelEdit"
      ref="input"
      class="editable-input"
      :class="{active: editing}"
      placeholder="-"
      :disabled="disabled"
      :state="state"
      lazy-formatter
      :formatter="formatter"
      :key="componentKey"
  />
</template>

<script>
  export default {
    data: function () {
      return {
        editing: false,
        valueData: this.value,
        oldValue: this.value,
        componentKey: 0,
      }
    },
    props: {
      inputType: String,
      value: {
        validator: function (val) {
          return typeof val === 'number' || typeof val === 'string';
        },
      },
      isTextarea: {
        default: false,
        type: Boolean,
      },
      rows: {
        default: "1",
        type: String,
      },
      maxRows: {
        default: "4",
        type: String,
      },
      autoselect: {
        default: true,
        type: Boolean,
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      state: {
        type: Boolean,
        required: false,
        default: null
      }
    },
    computed: {
      shownValue: function () {
        return this.value ? this.value : '--'
      },
    },
    methods: {
      startEdit: function () {
        this.oldValue = this.value
        this.editing = true
        if (this.autoselect) {
          this.$nextTick(() => this.$refs.input.select())
        }
      },
      endEdit: function () {
        if (this.valueData) this.valueData = this.valueData.trim()
        this.$emit('input', this.valueData)
        this.editing = false
      },
      cancelEdit: function () {
        this.valueData = this.oldValue
        this.forceBlur()
      },
      forceBlur: function () {
        this.$refs.input.blur()
      },
      forceRerenderer: function () {
        this.componentKey += 1
      },
      formatter: function (value) {
        if ((this.inputType === "time" || this.inputType === "number") && value === "") {
          this.forceRerenderer()
          return null
        } 
        return value
      }
    },
    watch: {
      value: function(val) {
        this.valueData = val;
      }
    }
  }
</script>
<style scoped lang="scss">
  .editable-input {
    width: 100%;
    height: 100%;
    text-align: center;
    overflow-y: auto !important;
    border-radius: 0;
    background-color: transparent;
    border: none;

    &:hover {
      background-color: $hover-background-color;
    }

    &.active {
      background-color: $active-background-color;
    }
  }

  input:focus, input:active {
    box-shadow: none;
    border: none;
    outline: none;
  }

  .form-control {
    color: #555;
  }

</style>